import React from "react";
import { C, radii, space, type } from "../../styles/tokens";

/**
 * VerifiedBanner (docs/BRAND_MANUAL.md, section 8)
 * What a check confirmed sits in one row on success tint (#DCF5E7):
 *  - White circle with green checkmark
 *  - Overline eyebrow ("GST verified", "Identity verified")
 *  - Name (bodyStrong, navy)
 *  - Detail (caption, textMuted)
 */
export function VerifiedBanner({ eyebrow, name, detail, style = {} }) {
  return (
    <div
      role="status"
      style={{
        display: "flex",
        alignItems: "center",
        gap: space.md, // 12px
        padding: `${space.md}px ${space.lg}px`, // 12px 16px
        borderRadius: radii.card, // 16px
        backgroundColor: C.successTint,
        marginBottom: space.lg,
        boxSizing: "border-box",
        ...style,
      }}
    >
      {/* White circle with green tick */}
      <div
        style={{
          width: 40,
          height: 40,
          borderRadius: radii.pill,
          backgroundColor: C.surface,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
          color: C.success,
        }}
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
          <path d="m9 12 2 2 4-4" />
        </svg>
      </div>

      <div style={{ flex: 1, minWidth: 0 }}>
        {eyebrow && (
          <div
            style={{
              color: C.success,
              fontSize: type.overline.fontSize,
              lineHeight: type.overline.lineHeight,
              fontWeight: type.overline.fontWeight,
              textTransform: type.overline.textTransform,
              letterSpacing: type.overline.letterSpacing,
            }}
          >
            {eyebrow}
          </div>
        )}
        <div
          style={{
            color: C.navy,
            fontSize: type.bodyStrong.fontSize,
            lineHeight: type.bodyStrong.lineHeight,
            fontWeight: type.bodyStrong.fontWeight,
            wordBreak: "break-word",
          }}
        >
          {name}
        </div>
        {detail && (
          <div
            style={{
              color: C.textMuted,
              fontSize: type.caption.fontSize,
              lineHeight: type.caption.lineHeight,
              fontWeight: type.caption.fontWeight,
              marginTop: 2,
            }}
          >
            {detail}
          </div>
        )}
      </div>
    </div>
  );
}
